<template>
  <!-- destroy-on-close -->
  <yd-dialog
    :title="title"
    :visible.sync="visible"
    append-to-body
    @close="closeDataView"
    @open="openData"
    width="60%"
  >
    <div>
      <div class="top-box">
        <div>
          <el-tag type="danger" effect="dark">
            <div>曝光量</div>
            <div>{{ advertisingData.totalExposureNum || 0 }}</div>
          </el-tag>
          <el-tag type="warning" effect="dark">
            <div>点击量</div>
            <div>{{ advertisingData.totalClickNum || 0 }}</div>
          </el-tag>
          <el-tag type="success" effect="dark">
            <div>点击率</div>
            <div>{{ advertisingData.totalPercentage || 0 }}%</div>
          </el-tag>
        </div>
        <div>
          <el-date-picker
            v-model="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            size="mini"
            style="width: 220px"
            @change="daterangeChange"
          />
        </div>
      </div>
      <div class="select-box">
        <el-select v-model="chartType" placeholder="请选择" clearable size="mini">
          <el-option
            v-for="item in chartTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div class="test2" ref="myChart" style="width: 600px; height: 400px">
        <div id="myChart" style="width: 100%; height: 278px"></div>
      </div>
      <el-table :data="records" border size="mini" max-height="220">
        <el-table-column label="日期" prop="recordDate" align="center" />
        <el-table-column label="曝光量" prop="exposureNum" align="center" />
        <el-table-column label="点击量" prop="clickNum" align="center" />
        <el-table-column label="点击率" prop="endTime" align="center">
          <template slot-scope="scope">
            {{ (scope.row.percentage * 100 || 0).toFixed(2) }}%
          </template>
        </el-table-column>
        <el-table-column label="对比" prop="percentage" align="center" />
      </el-table>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDataView">返 回</el-button>
    </div>
  </yd-dialog>
</template>
<script>
  import { advertisingDataFetch } from '@/api/marketing/advertising'
  import { cloneDeep, isNumber } from 'lodash-es'

  export default {
    name: 'test2',
    props: {},
    data() {
      return {
        visible: false,
        title: '',
        records: [],
        chartType: 1,
        myChart: '',
        advertisingData: {},
        daterange: [],
        chartTypeList: [
          { value: 1, label: '曝光量' },
          { value: 2, label: '点击量' }
        ],
        xData: [],
        exposureUvData: [],
        exposurePvData: [],
        uvData: [],
        pvData: [],
        pickerMinDate: null,
        pickerMaxDate: null,
        // 日期使用
        pickerOptions: {
          onPick: ({ maxDate, minDate }) => {
            if (minDate && this.pickerMinDate) {
              this.pickerMinDate = null
            } else if (minDate) {
              this.pickerMinDate = minDate.getTime()
            }
          },
          disabledDate: (time) => {
            if (this.pickerMinDate) {
              return (
                time.getTime() > this.pickerMinDate + 29 * 24 * 3600 * 1000 ||
                time.getTime() < this.pickerMinDate - 29 * 24 * 3600 * 1000
              )
            }
            return false
          }
        }
      }
    },
    watch: {
      chartType(value) {
        if (value === 1) {
          this.uvData = this.exposureUvData
          this.pvData = this.exposurePvData
          this.drawLine()
        } else {
          this.uvData = this.clickUvData
          this.pvData = this.clickPvData
          this.drawLine()
        }
      }
    },
    methods: {
      init(id, title) {
        this.advertisingId = id
        this.title = title
        this.getAdvertisingData()
      },
      getAdvertisingData() {
        let startDate = ''
        let endDate = ''
        if (Array.isArray(this.daterange) && this.daterange.length === 0) {
          startDate = this.getDate().startDate
          endDate = this.getDate().endDate
          this.daterange = [startDate, endDate]
        } else {
          startDate = this.daterange[0]
          endDate = this.daterange[1]
        }
        const params = {
          advertisingId: this.advertisingId,
          startDate,
          // startDate: '2022-01-01',
          endDate
          // endDate: '2023-02-02',
        }
        this.$loading()
        advertisingDataFetch(params)
          .then((res) => {
            const { code, data } = res
            if (code === 0) {
              if (!data.detailAdvertisingDataDateStatistics) {
                this.$message.info('暂无数据！')
                return
              }
              this.advertisingData = data
              const totalPercentage = this.advertisingData.totalPercentage
              if (isNumber(totalPercentage)) {
                this.advertisingData.totalPercentage = parseFloat(
                  (totalPercentage * 100).toFixed(2)
                )
              }
              this.records = data.detailAdvertisingDataDateStatistics
              const arr = cloneDeep(this.records).reverse()
              this.xData = arr.map((item) => {
                const index = item.recordDate.indexOf('-')
                return item.recordDate.slice(index + 1)
              })
              this.exposureUvData = arr.map((item) => {
                return item.exposurePersonNum
              })
              this.exposurePvData = arr.map((item) => {
                return item.exposureNum
              })
              this.clickUvData = arr.map((item) => {
                return item.clickPersonNum
              })
              this.clickPvData = arr.map((item) => {
                return item.clickNum
              })
              this.uvData = this.exposureUvData
              this.pvData = this.exposurePvData
              this.visible = true
            }
          })
          .finally(() => {
            this.$loading().close()
            this.drawLine()
          })
      },
      drawLine() {
        // 基于准备好的dom，初始化echarts实例
        this.myChart2 = this.$echarts.init(this.$refs.myChart)
        // 绘制图表
        this.myChart2.setOption({
          // title: {
          //     text: '近5次班级出勤情况', // 主标题
          //     subtext: '', // 副标题
          //     x: 'left' // x轴方向对齐方式
          // },
          tooltip: {
            trigger: 'axis' // axis   item   none三个值
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.xData, // x轴数据
            name: '' // x轴名称
          },
          yAxis: {
            type: 'value',
            name: '' // y轴名称
          },
          legend: {
            data: ['UV', 'PV']
          },
          series: [
            {
              name: 'UV',
              data: this.uvData,
              type: 'line'
            },
            {
              name: 'PV',
              data: this.pvData,
              type: 'line'
            }
          ]
        })
      },
      closeDataView() {
        this.daterange = []
        this.advertisingData = {}
        this.records = []
        this.title = ''
        this.visible = false
      },
      daterangeChange() {
        this.getAdvertisingData()
      },
      getDate() {
        const now = new Date()
        const before = new Date(now - 1000 * 60 * 60 * 24 * 30)
        const year = before.getFullYear()
        let month = before.getMonth() + 1 // 得到月份
        let date = before.getDate()
        const nowYear = now.getFullYear() // 得到年份
        let newDate = now.getDate() // 得到日期
        let nowMonth = now.getMonth() + 1
        if (month === 0) {
          month = 12
        }
        nowMonth = nowMonth.toString().padStart(2, '0')
        month = month.toString().padStart(2, '0')
        date = date.toString().padStart(2, '0')
        newDate = newDate.toString().padStart(2, '0')
        const startDate = `${year}-${month}-${date}`
        const endDate = `${nowYear}-${nowMonth}-${newDate}`
        return { startDate, endDate }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .el-tag {
    height: auto;
    text-align: center;
    font-size: 16px;
    margin-right: 15px;
    width: 100px;
  }

  .top-box {
    display: flex;
    justify-content: space-between;
  }

  .select-box {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
    margin-right: 20px;
  }
</style>
